import orderflowHelper from '@/config/order'
import { sampleType } from 'json/goods-order-options'
import { adultOrderSaleFrom } from 'json/lab-order'
let statusOptions = [
  {
    label: '样本接收',
    value: 'LAB_SAMPLES_RECEIVED'
  }, {
    label: '制备',
    value: 'PREPARED'
  }, {
    label: '入库',
    value: 'WAREHOUSING'
  }, {
    label: '报告生成',
    value: 'REPORT_CHECKED_1ST'
  }, {
    label: '已完成',
    value: 'COMPLETED'
  }
]
export let filterFactor = [ {
  label: '待操作状态',
  type: 'select',
  clearable: true,
  value: 'targetStatus', // 需返回数据的字段名
  options: getLabStatusOptions()
}, {
  label: '订单操作时间',
  type: 'time-slot',
  value: 'operationTime',
  startName: 'opStartTime',
  endName: 'opEndTime' // 需返回数据的字段名
}, {
  label: '已操作状态',
  type: 'select',
  clearable: true,
  value: 'completeStatus', // 需返回数据的字段名
  // options: getLabStatusOptions()
  // 暂时只支持样本接收以及核酸提取的操作时间筛选，将来扩充其他状态
  options: statusOptions
}, {
  label: '样本类型',
  type: 'select',
  clearable: true,
  value: 'sampleTypes', // 需返回数据的字段名
  options: sampleType
}, {
  label: '订单来源',
  type: 'select',
  clearable: true,
  value: 'salesFroms', // 需返回数据的字段名
  options: adultOrderSaleFrom
}
// {
//   label: '商品名称',
//   type: 'select',
//   clearable: true,
//   value: 'salesFroms', // 需返回数据的字段名
//   options: labOrderSaleFrom
// }
]

function getLabStatusOptions () {
  let options = []
  let notInclude = ['LAB_SAMPLE_RETURNED', 'CREATED', 'COMPLETED']
  orderflowHelper.getAdultSellOrder().forEach(item => {
    let signalItem = {
      label: item.operation,
      value: item.name
    }
    if (!notInclude.includes(signalItem.value)) {
      options.push(signalItem)
    }
  })
  return options
}
